import { css } from "styled-components";

export const linkStyles = css`
  .ABB_CommonUX_Link__container {
    display: inline !important;
  }
`;
